import { render, staticRenderFns } from "./SettingUpdate.vue?vue&type=template&id=4c0f90e2&scoped=true&"
import script from "./SettingUpdate.vue?vue&type=script&lang=js&"
export * from "./SettingUpdate.vue?vue&type=script&lang=js&"
import style0 from "./SettingUpdate.vue?vue&type=style&index=0&id=4c0f90e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0f90e2",
  null
  
)

export default component.exports